import React from "react";
import styles from "./TablePadCard.module.scss";

export const TablePadCard = ({ modelName, image, selected = false, selectable = true, onSelect }) => {
  const handleClick = () => selectable && onSelect?.();

  return (
    <div
      className={`${styles.card} ${selectable ? styles.card_selectable : ""} ${selected ? styles.card_selected : ""}`}
      role={selectable ? "radio" : undefined}
      aria-checked={selectable ? selected : undefined}
      tabIndex={selectable ? 0 : -1}
      onClick={handleClick}
      onKeyDown={(e) => selectable && (e.key === "Enter" || e.key === " ") && handleClick()}
    >
      <div className={styles.cardHeader}>
        <span className={styles.modelName}>{modelName}</span>
        {selectable && (
          <span className={`${styles.radio} ${selected ? styles.radio_checked : ""}`} aria-hidden="true">
            {selected && <span className={styles.radioDot} />}
          </span>
        )}
      </div>
      <div className={styles.imageWrap}>
        <img src={image} alt={modelName} className={styles.image} loading="lazy" />
      </div>
    </div>
  );
};
